<template>
<svg viewBox="0 0 48 48" fill="none" :class="[`${prefix}-icon`, `${prefix}-icon-pen`]" width="1em" height="1em" v-bind="$attrs"><path d="M28.364 11.565l7.071 7.071M7.151 32.778L33.314 6.615l7.07 7.071L14.223 39.85H7.15v-7.07z" stroke="#4E5969" stroke-width="4"/></svg>
</template>
<script>

export default {
  name: 'IconPen',
  props: {
    prefix: {
        type: String,
        default: 'zhilv',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
